import { utilities as useCases } from 'core/use-cases';

import { store } from '../store';

const { Provider: StoreProvider } = useCases;

export function ProviderForTest({ children }: { children: React.ReactNode }) {
  return <StoreProvider store={store}>{children}</StoreProvider>;
}
